import React from "react";
import { Box, Button, Typography, Tooltip } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SaveIcon from "@mui/icons-material/Save";
import axiosClient from "../../axios";

const UploadDocuments = ({
  requirementsDocuments,
  setRequirementsDocuments,
  setCurrentReqID,
  setCurrentReqDetails,
  setOpenDocumentsModal,
  setRequirements,
  requirements,
  requirement,
}) => {
  const handleClickDocuments = (requirement_id, requirement_details) => () => {
    // console.log("Req ID: ", requirement_id);
    setCurrentReqID(requirement_id);
    setCurrentReqDetails(requirement_details);
    setOpenDocumentsModal(true);
  };

  const handleUploadReqFiles = (requirement_id) => async () => {
    if (requirementsDocuments[requirement_id] !== undefined) {
      // Create a single FormData object
      const formData = new FormData();
      
      // Create an array of files and add them to FormData
      const files = [...requirementsDocuments[requirement_id]];
      
      files.forEach((file) => {
        formData.append("files[]", file); 
      });
      
      const updatedRequirements = [...requirements];
      
      try {        
        // Upload all files at once
        await uploadDocuments(formData, requirement_id, updatedRequirements);
        
        // Update state when all uploads finish
        setRequirements(updatedRequirements);
        
        // Alert that attached files uploaded successfully
        window.alert("Files uploaded successfully!");
        setRequirementsDocuments({});
      } catch (error) {
        window.alert(
          "Error uploading files: " +
            (error.response?.data?.message || error.message)
        );
      }
    }
  };
  
  const uploadDocuments = async (formData, requirement_id, updatedRequirements) => {
    // console.log("Files to upload:", formData.getAll("files[]"));
    try {
      const response = await axiosClient.post(
        `/inspections/requirements/upload_requirement_images/${requirement_id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      
      // Process the response
      const requirementId = parseInt(response.data.requirement_id);
      const filePaths = response.data.file_paths;
      
      // Update the requirements array with the new file paths
      updatedRequirements.forEach((req) => {
        if (req.id === requirementId) {
          if (!req.file_path) {
            req.file_path = []; // Initialize as array if it doesn't exist
          }
          
          if (Array.isArray(filePaths)) {
            // If filePaths is an array, add each path
            req.file_path = [...req.file_path, ...filePaths];
          } else if (filePaths) {
            // If filePaths is a single value
            req.file_path.push(filePaths);
          }
        }
      });
      
      return response;
    } catch (error) {
      console.error("ERROR uploading files:", error.response?.data || error);
      throw error;
    }
  };

  return (
    <div>
      {/* Upload button */}
      <Box
        onClick={handleClickDocuments(
          requirement.id,
          requirement.requirement_details
        )}
      >
        {/* If requirementsDocuments[requirement.id] length > 0 display files attached */}
        {requirementsDocuments &&
          requirementsDocuments?.[requirement.id] &&
          Array.isArray(requirementsDocuments[requirement.id]) && (
            <Typography>
              {requirementsDocuments[requirement.id].length} files attached
            </Typography>
          )}
        <Tooltip title="Upload files for this requirement">
          <Button startIcon={<FileUploadIcon />} />
        </Tooltip>
      </Box>

      {requirementsDocuments?.[requirement.id]?.length > 0 && (
        <Box onClick={handleUploadReqFiles(requirement.id)}>
          <Tooltip title="Save files for this requirement">
            <Button startIcon={<SaveIcon />} />
          </Tooltip>
        </Box>
      )}
    </div>
  );
};

export default UploadDocuments;
